import api from "./index";

export const GetAreaModeId = async () => {
  try {
    const response = await api.get("/api/area-types");
    return response.data;
  } catch (error) {
    console.error("영역 모드 조회 실패:", error);
    throw error;
  }
};

export const PostAreaMode = async (data) => {
  const sendDataToServer = {
    typeName: data.newAreaName,
    typeColor: data.areaColor,
  };

  try {
    const response = await api.post("/api/area-types", sendDataToServer);
    return response.data;
  } catch (error) {
    console.error("영역 모드 생성 실패:", error);
    throw error;
  }
};

export const DeleteAreaMode = async (id) => {
  try {
    const response = await api.delete(`/api/area-types/${id}`);
    return response.data;
  } catch (error) {
    console.error("영역 모드 삭제 실패:", error);
    throw error;
  }
};
